import React, { useState } from 'react'
import { CarBrand } from '../../../types/modules/admin/carBrand.type'
import { Edit } from 'lucide-react'
import CustomModal from '../../ui/CustomModal'
import { useTranslation } from 'react-i18next'
import { variantCategory } from '../../../types/modules/admin/variantCategory.type'
import UpdateVariantCategoryForm from './UpdateVariantCategoryForm'
import { formatNumber } from '../../../utils/formatNumber'
import { PermissionGate } from '../PermissionGate'
import { PermissionsKey } from '../../../data/permissions'

type Props ={
    variant:variantCategory
}

function VariantCategoryItem({variant}:Props) {
        const [isOpen, setIsOpen] = useState(false);
        const {t}= useTranslation();
        const enName = variant.languages.find(s=>s.languageCode==="en")?.name ||"";
        const arName = variant.languages.find(s=>s.languageCode==="ar")?.name ||"";
  return (
    <>
        <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        {formatNumber(variant.id)}
        </td>

        <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        {enName}
        </td>

        <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        {arName}
        </td>

        <PermissionGate permissions={[PermissionsKey.UpdateVariantCategory]}>
            <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
            <button onClick={()=>setIsOpen(p=>!p)}>
                <Edit/>
            </button>
            </td>
        </PermissionGate>
        <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <UpdateVariantCategoryForm
            defaultValues={{
            languages: [
            { languageCode: "en", title: enName },
            { languageCode: "ar", title: arName },
            ],
        }}
        id={variant.id}
        onSubmitSuccess={() => {
            setIsOpen(p=>false);
  }}
        />
        </CustomModal>
    </>
  )
}

export default VariantCategoryItem